<template>
  <div class="content course-idx-content">
    <div class="idx-banner">
      <div class="box">

       <swiper :options="swiperOption1" ref="mySwiper">
         <template v-for="(item, index) in banners">
           <swiper-slide>

            <template v-if="item.url!=''">
             <a :href="item.url ">
               <el-row>
                 <el-col :xs="24" :sm="13" :lg="16" class="el-right">
                   <div class="idx-banner-img"><img :src="item.picUrl" width="700" height="432" /></div>
                 </el-col>
                 <el-col :xs="24" :sm="11" :lg="8" class="">
                   <div class="idx-banner-txt">
                     <p>{{ item.title }}</p>
                   </div>
                 </el-col>
               </el-row>
               </a>
             </template>

             <template v-if="item.url===''">
                <el-row>
                  <el-col :xs="24" :sm="13" :lg="16" class="el-right">
                    <div class="idx-banner-img"><img :src="item.picUrl" width="700" height="432" /></div>
                  </el-col>
                  <el-col :xs="24" :sm="11" :lg="8" class="">
                    <div class="idx-banner-txt">
                      <p>{{ item.title }}</p>
                    </div>
                  </el-col>
                </el-row>
              </template>
           </swiper-slide>
          </template>

        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-next swp1 qjico arrow-right1"></div>
        <div class="swiper-button-prev swp1 qjico arrow-left1"></div>
      </div>
    </div>
    <!--免费课程-->
    <div class="course-idx-wrap">
         <div class="idx-common-hd">
           <h2 class="title">十大场景教学覆盖企业服务培训需求</h2>
           <p class="desc">想提升服务技术？想迅速升职？想成为行业翘楚？弘范导师为您转身</p>
         </div>
        <div class="course-box">
          <el-row :gutter="20">
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/1" target="_blank">
              <div class="item">
                <div class="txt">保洁员仪容仪表</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_01.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/2" target="_blank">
              <div class="item">
                <div class="txt">认识清洁药剂——常用清洁剂</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_02.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/3" target="_blank">
              <div class="item">
                <div class="txt">揭秘玻璃刮擦的方法</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_03.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/4" target="_blank">
              <div class="item">
                <div class="txt">卫生间清洁解析</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_04.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/5" target="_blank">
              <div class="item">
                <div class="txt">办公室清洁讲解</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_05.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/6" target="_blank">
              <div class="item">
                <div class="txt">楼道清洁流程与细节</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_06.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/7" target="_blank">
              <div class="item">
                <div class="txt">楼梯清洁的注意事项</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_07.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/8" target="_blank">
              <div class="item">
                <div class="txt">两种电梯清洁的方法</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_08.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/9" target="_blank">
              <div class="item">
                <div class="txt">大堂清洁的诀窍 </div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_09.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
            <el-col :xs="12" class="course-col-lg-5">
              <a href="/freeCourses/10" target="_blank">
              <div class="item">
                <div class="txt">停车场清洁攻略</div>
                <div class="img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course_10.png" width="200" height="112"></div>
              </div>
              </a>
            </el-col>
          </el-row>
        </div>
    </div>

    <div class="teaching-model">
        <div class="idx-common-hd">
          <h2 class="title">因材施教 分级培优 专注教与学</h2>
          <p class="desc">不同学员情况选择不同班型</p>
        </div>
        <div class="teaching-model-box">
           <el-row>
             <el-col :xs="24" :lg="12">
               <div class="item l-item">
                   <img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/course/course001.jpg" width="960" height="356">
               </div>
             </el-col>
             <el-col :xs="24" :lg="12">
               <div class="item r-item">
                 <el-row>
                   <el-col :xs="24" :lg="12">
                        <div class="i-box">
                          <div class="tit">师生多渠道互动</div>
                          <div class="desc">小组讨论、在线问答、增进师生互动</div>
                        </div>
                   </el-col>
                   <el-col :xs="24" :lg="12">
                        <div class="i-box">
                          <div class="tit">任务式教学计划</div>
                          <div class="desc">教学计划结合任务机制，有效规划和把控学员学习进程</div>
                        </div>
                   </el-col>
                   <el-col :xs="24" :lg="12">
                        <div class="i-box">
                          <div class="tit">专业技能实操考试</div>
                          <div class="desc">自主选题，理论及实操相结合</div>
                        </div>
                   </el-col>
                   <el-col :xs="24" :lg="12">
                        <div class="i-box">
                          <div class="tit">自动化考试系统</div>
                          <div class="desc">自动化组卷阅卷，高效实现在线考试</div>
                        </div>
                   </el-col>
                 </el-row>
               </div>
             </el-col>
           </el-row>
        </div>
    </div>

     <div class="course-class">
       <el-row :gutter="20">
           <el-col :xs="12" :lg="4"><div class="item"><a href="/paidCourses/9" target="_blank"><img src="http://image.jiemancang.com/image/2020-02-07/1581061585433.jpg" width="240" height="136"></a></div></el-col>
           <el-col :xs="12" :lg="4"><div class="item"><a href="/paidCourses/7" target="_blank"><img src="http://image.jiemancang.com/image/2020-02-07/1581061348774.jpg" width="240" height="136"></a></div></el-col>
           <el-col :xs="12" :lg="4"><div class="item"><a href="/paidCourses/8" target="_blank"><img src="http://image.jiemancang.com/image/2020-02-07/1581061544608.jpg" width="240" height="136"></a></div></el-col>
           <el-col :xs="12" :lg="4"><div class="item"><a href="/paidCourses/10" target="_blank"><img src="http://image.jiemancang.com/image/2020-02-07/1581061514911.jpg" width="240" height="136"></a></div></el-col>
           <el-col :xs="12" :lg="4"><div class="item"><a href="/paidCourses/11" target="_blank"><img src="http://image.jiemancang.com/image/2020-02-07/1581061466810.jpg" width="240" height="136"></a></div></el-col>
           <el-col :xs="12" :lg="4"><div class="item"><a href="/paidCourses/16" target="_blank"><img src="http://image.jiemancang.com/image/2020-02-07/1581062490779.jpg" width="240" height="136"></a></div></el-col>
     </el-row>
     </div>
     <div class="course-share">
       <div class="idx-common-hd">
         <h2 class="title">清洁服务技术教学分享</h2>
         <p class="desc">让您从容应对清洁服务各种难点场景</p>
       </div>
        <el-row :gutter="20">
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/26" target="_blank">
              <div class="item">
                 <div class="tit">开荒保洁技能流程分享</div>
                 <div class="box">
                   <div class="l-txt">对新交付使用建筑的清洁工作，清洁强度大、难度高</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share01.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/27" target="_blank">
              <div class="item">
                 <div class="tit">高空清洁安全技能分享</div>
                 <div class="box">
                   <div class="l-txt">工人在高空作业时操作机器设备和调整仪器仪表必须遵守的程序</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share02.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/28" target="_blank">
              <div class="item">
                 <div class="tit">壁挂炉清洁保养技能分享</div>
                 <div class="box">
                   <div class="l-txt">供暖停止之后，需要对取暖设备进行清洁养护才能够延长设备寿命</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share03.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/29" target="_blank">
              <div class="item">
                 <div class="tit">吸尘器使用技巧分享</div>
                 <div class="box">
                   <div class="l-txt">吸尘器是日常清洁工作的常用工具，正确使用吸尘器是清洁人员的基本功</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share04.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/30" target="_blank">
              <div class="item">
                 <div class="tit">室内除醛灭菌方案（部分）分享</div>
                 <div class="box">
                   <div class="l-txt">清除室内的甲醛和其他有害物环境，保证业主和客户的呼吸健康</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share05.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/31" target="_blank">
              <div class="item">
                 <div class="tit">常见木地板种类清洁注意事项</div>
                 <div class="box">
                   <div class="l-txt">本课在于解读不同木木质的地板在清洁过程中各自需要注意的事项</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share06.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/32" target="_blank">
              <div class="item">
                 <div class="tit">洁厕剂甄选方法技巧分享</div>
                 <div class="box">
                   <div class="l-txt">本课程讲授清洁人员如何甄别洁厕剂产品质量是否满足清洁需求</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share07.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
            <el-col :xs="24" :lg="6">
              <a href="/px/shareCourses/33" target="_blank">
              <div class="item">
                 <div class="tit">滚筒洗衣机的清洁剂清洁技巧分享</div>
                 <div class="box">
                   <div class="l-txt">本课讲述滚筒洗衣机清洁的基本步骤和具体操作方法</div>
                   <div class="l-img"><img src="https://jiemancang.oss-cn-beijing.aliyuncs.com/hongfanzhihui/images/tech-share08.png" width="100" height="100"></div>
                 </div>
              </div>
              </a>
            </el-col>
         </el-row>
     </div>

     <div class="serve-object">
        <div class="idx-common-hd">
          <h2 class="title">服务企业与组织</h2>
          <p class="desc">以培训启动企业转型升级引擎</p>
        </div>
        <div class="s-object-box pc-none">

             <swiper :options="swiperOption2" ref="mySwiper2">
             <template v-for="item in trainings">
                <swiper-slide>
                   <a :href="'/px/innerCourses/'+item.id" target="_blank">
                       <div class="item">
                         <img :src="item.picUrl" width="640" height="360" />
                         <p class="txt">{{item.title}}</p>
                       </div>
                   </a>
               </swiper-slide>
             </template>
             </swiper>
            <div class="swiper-button-next swp2"></div>
            <div class="swiper-button-prev swp2"></div>
        </div>
        <div class="s-object-box m-none">

             <swiper :options="swiperOption3" ref="mySwiper3">
             <template v-for="item in trainings">
                <swiper-slide>
               <a :href="'/px/innerCourses/'+item.id" target="_blank">

                   <div class="item">
                     <img :src="item.picUrl" />
                     <p class="txt">{{item.title}}</p>
                   </div>


               </a> </swiper-slide>
             </template>
             </swiper>
 <div class="swiper-button-next swp3"></div>
            <div class="swiper-button-prev swp3"></div>
        </div>
     </div>

  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper';
  require('swiper/dist/css/swiper.css');

  export default {
    components: {
      swiper,
      swiperSlide
    },
 data() {
    return {
      swiperOption1: {
        autoplay: {
        delay: 3000,
        },
      pagination: {
        el: '.swiper-pagination'
      },
        observer: true,
        observeParents: true,
        speed: 500,
        spaceBetween: 20,
         watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.swp1', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev.swp1' ,//后退按钮的css选择器或HTML元素。
          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden" //按钮隐藏时的Class
        }
      },
      swiperOption2: {
        autoplay: {
        delay: 3000,
        },
      pagination: {
        el: '.swiper-pagination2'
      },
      slidesPerView: 3,
        observer: true,
        observeParents: true,
        speed: 500,
         watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.swp2', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev.swp2' ,//后退按钮的css选择器或HTML元素。
          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden" //按钮隐藏时的Class
        }
      },
  swiperOption3: {
        autoplay: {
        delay: 3000,
        },
      pagination: {
        el: '.swiper-pagination3'
      },
      slidesPerView: 1,
        observer: true,
        observeParents: true,
        speed: 500,
         watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next.swp3', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev.swp3' ,//后退按钮的css选择器或HTML元素。
          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden" //按钮隐藏时的Class
        }
      },
      path: domain.apiUrl,
      banner_code: 9,//banner code值

      banners: [],//banners
      trainings: [],//内训
    };
 },
    created() {
      this.banner();
      this.training();
    },
    methods: {
      banner: function() {
        let formData = {};
        formData.code = this.banner_code;
        this.$http.get(this.path + 'recomModel/list',{params:formData}).then((response) => {
          if (response.status === 200) {
            this.banners = response.data;
          }
        }, (response) => {
          this.$message.error("error")
        });
      },
      training: function() {
        this.$http.get(this.path + 'essay/list?type=3').then((response) => {
          if (response.status === 200) {
            console.log(response.data)
            this.trainings = response.data;
          }
        }, (response) => {
          this.$message.error("error")
        });
      },
    },

}
</script>

<style lang="scss">
@import '../assets/css/index.scss';
@import '../assets/css/courseindex.scss';
</style>



// WEBPACK FOOTER //
// src/components/coursesIndex.vue